import * as yup from 'yup';

import { StringTypeBase } from '../../types/baseTypes/StringTypeBase';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_OTHER } from '../constants';

/**
 * A special type that refers just to other keys (i.e. field names, property names) in this object.
 */
/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use KeyType from application-types instead.
 */
export class KeyType extends StringTypeBase {
  group = TYPE_GROUP_OTHER;

  name = 'Key';

  get default(): any {
    return '';
  }

  friendlyName = 'Key';

  contexts = [TypeContextEnum.Block];

  superUserOnly = true;

  buildSchema() {
    return yup.string().nullable();
  }
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Key from application-types instead.
 */
const definition = new KeyType();

Types.addBaseType(definition);
export default definition;
